"use strict";

exports.__esModule = true;
exports.LineChartSeries = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _d3Shape = require("d3-shape");
var _ChartTooltip = require("../ChartTooltip");
var _UiDesignContext = require("../../Theme/UiDesign/UiDesignContext");
var _excluded = ["color", "width", "height", "series", "xScale", "yScale", "curve", "showChartTooltip", "xPosition", "mouseOverChart", "strokeDasharray"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var LineChartSVG = _styledComponents["default"].svg.withConfig({
  displayName: "LineChartSeries__LineChartSVG",
  componentId: "sc-1b9ihod-0"
})(["pointer-events:bounding-box;"]);
var curveDict = {
  linear: _d3Shape.curveLinear,
  step: _d3Shape.curveStep,
  stepBefore: _d3Shape.curveStepBefore,
  stepAfter: _d3Shape.curveStepAfter,
  basis: _d3Shape.curveBasis,
  cardinal: _d3Shape.curveCardinal,
  monotoneX: _d3Shape.curveMonotoneX,
  catmullRom: _d3Shape.curveCatmullRom
};
var getCurve = function getCurve(nameOrImpl) {
  if (typeof nameOrImpl === "function") {
    return nameOrImpl;
  }
  return curveDict[nameOrImpl];
};
var defaultProps = {
  curve: "linear",
  color: "steelblue",
  showChartTooltip: false
};

/**
 * Displays a line chart series.
 */
// eslint-disable-next-line no-shadow
var LineChartSeries = exports.LineChartSeries = /*#__PURE__*/function (_Component) {
  function LineChartSeries() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.registerContainer = function (container) {
      _this.container = container;
    };
    _this.getTooltipLabel = function () {
      var _this$props = _this.props,
        xScale = _this$props.xScale,
        series = _this$props.series,
        position = _this$props.xPosition;
      if (!position) {
        return;
      }
      var data = series.data,
        getXValue = series.getXValue,
        getYValue = series.getYValue;
      return data.reduce(function (yValueAtPosition, item) {
        return xScale(getXValue(item)) <= position ? getYValue(item) : yValueAtPosition;
      }, null);
    };
    return _this;
  }
  _inheritsLoose(LineChartSeries, _Component);
  var _proto = LineChartSeries.prototype;
  _proto.render = function render() {
    var _this2 = this;
    // eslint-disable-next-line no-unused-vars
    var _this$props2 = this.props,
      color = _this$props2.color,
      width = _this$props2.width,
      height = _this$props2.height,
      series = _this$props2.series,
      xScale = _this$props2.xScale,
      yScale = _this$props2.yScale,
      curve = _this$props2.curve,
      showChartTooltip = _this$props2.showChartTooltip,
      xPosition = _this$props2.xPosition,
      mouseOverChart = _this$props2.mouseOverChart,
      strokeDasharray = _this$props2.strokeDasharray,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    var data = series.data,
      getXValue = series.getXValue,
      getYValue = series.getYValue;
    var strokeColor = typeof color === "function" ? color(data[0]) : color;
    var points = (0, _d3Shape.line)().curve(getCurve(curve)).x(function (item) {
      return xScale(getXValue(item));
    }).y(function (item) {
      return yScale(getYValue(item));
    });
    return /*#__PURE__*/_react["default"].createElement(LineChartSVG, _extends({
      width: width,
      height: height,
      ref: this.registerContainer
    }, extra), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: strokeColor,
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: this.context && this.context.modern ? "1.5" : "2",
      d: points(data),
      strokeDasharray: strokeDasharray
    }), showChartTooltip && mouseOverChart && typeof xPosition === "number" && /*#__PURE__*/_react["default"].createElement(_ChartTooltip.ChartTooltip, {
      width: width,
      height: height,
      handleHeight: height,
      xPosition: xPosition,
      getLabel: function getLabel() {
        return _this2.getTooltipLabel();
      }
    }));
  };
  return LineChartSeries;
}(_react.Component);
LineChartSeries.defaultProps = defaultProps;
LineChartSeries.contextType = _UiDesignContext.UiDesignContext;